<template>
    <div class="project-header" :class="[{'main-block': theme == '', 'normal': normal == ''}]">
        <svg-icon v-if="showBack == ''" icon-class="header_back" class="back" @click.native="back()"></svg-icon>
        <div class="title">
            <div class="text">
                <template v-if="title">{{title}}</template>
                <slot v-else></slot>
            </div>
        </div>
        <slot name="right"></slot>
        <svg-icon v-if="showClose == ''" icon-class="header_close" class="close" @click.native="close()"></svg-icon>
        <svg-icon v-if="showMenu == ''" icon-class="menu" class="menu" @click.native="showMenuContent = !showMenuContent"></svg-icon>

        <header-menus v-if="showMenuContent"></header-menus>
    </div>
</template>

<script>
import headerMenus from "../base/menu.vue";

export default {
    name: "sd-header",
    components: { headerMenus },
    props: {
        title: "",
        showClose: String,
        showBack: String,
        showMenu: String,
        theme: String,
        normal: String,
    },
    data() {
        return {
            showMenuContent: false,
            tabData: [{
                name: 'Home',
            },{
                name: 'Collections',
            },{
                name: 'Display',
            },{
                name: 'Cases',
            },{
                name: 'Account',
            }]
        }
    },
    methods: {
        back() {
            this.$emit("back")
        },

        close() {
            this.$emit("close")
        },

        menuClick(index) {
            let path = '';
            switch(index) {
                case 0: path = '/'; break;
                case 1: path = '/product'; break;
                case 2: path = '/2'; break;
                case 3: path = '/cases'; break;
                case 4: path = '/person'; break;
            }
            this.$router.push(path)
        }
    }
}
</script>

<style lang="scss" scoped>
    .project-header {
        height: 52px;
        // color: #0B0F23;
        // background: red;
        display: flex;
        align-items: center;
        text-align: center;
        position: relative;

        &.normal {
            height: 44px;
        }

        .back {
            left: 8px;
            position: absolute;
        }

        .title {
            font-weight: bold;
            font-size: 17px;
            flex: 1;

            .text {
                margin: 0 auto;
                max-width: 250px;
                overflow: hidden;//溢出隐藏
                white-space: nowrap;//禁止换行
                text-overflow: ellipsis;//...
            }
            
        }

        .close {
            right: 20px;
            position: absolute;
        }

        .menu {
            color: #0B0F23;
            width: 24px;
            height: 24px;
            right: 12px;
            position: absolute;
        }

        &.main-block {
            .back, .close {
                color: white;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/header.vue